export enum ReportSetting {
  COMPONENT_NUMBER = "COMPONENT_NUMBER",
  COMPONENT_NUMBER_REQUIRED = "COMPONENT_NUMBER_REQUIRED",
  LEV_NUMBER = "LEV_NUMBER",
  BATCH_NUMBER = "BATCH_NUMBER",
  SERIAL_NUMBER = "SERIAL_NUMBER",
  DELIVERY_NOTE = "DELIVERY_NOTE",
  MATERIAL_NUMBER = "MATERIAL_NUMBER",
  MEASURE_RESULT_1 = "MEASURE_RESULT_1",
  MEASURE_RESULT_2 = "MEASURE_RESULT_2",
  MEASURE_RESULT_3 = "MEASURE_RESULT_3",
  CUSTOM_FIELD_1 = "CUSTOM_FIELD_1",
  CUSTOM_FIELD_2 = "CUSTOM_FIELD_2",
  CUSTOM_FIELD_3 = "CUSTOM_FIELD_3",
  CUSTOM_FIELD_4 = "CUSTOM_FIELD_4",
  LEV_NUMBER_REQUIRED = "LEV_NUMBER_REQUIRED",
  BATCH_NUMBER_REQUIRED = "BATCH_NUMBER_REQUIRED",
  SERIAL_NUMBER_REQUIRED = "SERIAL_NUMBER_REQUIRED",
  DELIVERY_NOTE_REQUIRED = "DELIVERY_NOTE_REQUIRED",
  MATERIAL_NUMBER_REQUIRED = "MATERIAL_NUMBER_REQUIRED",
  MEASURE_RESULT_1_REQUIRED = "MEASURE_RESULT_1_REQUIRED",
  MEASURE_RESULT_2_REQUIRED = "MEASURE_RESULT_2_REQUIRED",
  MEASURE_RESULT_3_REQUIRED = "MEASURE_RESULT_3_REQUIRED",
  CUSTOM_FIELD_1_REQUIRED = "CUSTOM_FIELD_1_REQUIRED",
  CUSTOM_FIELD_2_REQUIRED = "CUSTOM_FIELD_2_REQUIRED",
  CUSTOM_FIELD_3_REQUIRED = "CUSTOM_FIELD_3_REQUIRED",
  CUSTOM_FIELD_4_REQUIRED = "CUSTOM_FIELD_4_REQUIRED",
  COMPONENT_NUMBER_KEYBOARD_TYPE = "COMPONENT_NUMBER_KEYBOARD_TYPE",
  LEV_NUMBER_KEYBOARD_TYPE = "LEV_NUMBER_KEYBOARD_TYPE",
  BATCH_NUMBER_KEYBOARD_TYPE = "BATCH_NUMBER_KEYBOARD_TYPE",
  SERIAL_NUMBER_KEYBOARD_TYPE = "SERIAL_NUMBER_KEYBOARD_TYPE",
  DELIVERY_NOTE_KEYBOARD_TYPE = "DELIVERY_NOTE_KEYBOARD_TYPE",
  MATERIAL_NUMBER_KEYBOARD_TYPE = "MATERIAL_NUMBER_KEYBOARD_TYPE",
  MEASURE_RESULT_1_KEYBOARD_TYPE = "MEASURE_RESULT_1_KEYBOARD_TYPE",
  MEASURE_RESULT_2_KEYBOARD_TYPE = "MEASURE_RESULT_2_KEYBOARD_TYPE",
  MEASURE_RESULT_3_KEYBOARD_TYPE = "MEASURE_RESULT_3_KEYBOARD_TYPE",
  CUSTOM_FIELD_1_KEYBOARD_TYPE = "CUSTOM_FIELD_1_KEYBOARD_TYPE",
  CUSTOM_FIELD_2_KEYBOARD_TYPE = "CUSTOM_FIELD_2_KEYBOARD_TYPE",
  CUSTOM_FIELD_3_KEYBOARD_TYPE = "CUSTOM_FIELD_3_KEYBOARD_TYPE",
  CUSTOM_FIELD_4_KEYBOARD_TYPE = "CUSTOM_FIELD_4_KEYBOARD_TYPE",
  COMPONENT_NUMBER_SCANNER_MODE = "COMPONENT_NUMBER_SCANNER_MODE",
  LEV_NUMBER_SCANNER_MODE = "LEV_NUMBER_SCANNER_MODE",
  BATCH_NUMBER_SCANNER_MODE = "BATCH_NUMBER_SCANNER_MODE",
  SERIAL_NUMBER_SCANNER_MODE = "SERIAL_NUMBER_SCANNER_MODE",
  DELIVERY_NOTE_SCANNER_MODE = "DELIVERY_NOTE_SCANNER_MODE",
  MATERIAL_NUMBER_SCANNER_MODE = "MATERIAL_NUMBER_SCANNER_MODE",
  MEASURE_RESULT_1_SCANNER_MODE = "MEASURE_RESULT_1_SCANNER_MODE",
  MEASURE_RESULT_2_SCANNER_MODE = "MEASURE_RESULT_2_SCANNER_MODE",
  MEASURE_RESULT_3_SCANNER_MODE = "MEASURE_RESULT_3_SCANNER_MODE",
  CUSTOM_FIELD_1_SCANNER_MODE = "CUSTOM_FIELD_1_SCANNER_MODE",
  CUSTOM_FIELD_2_SCANNER_MODE = "CUSTOM_FIELD_2_SCANNER_MODE",
  CUSTOM_FIELD_3_SCANNER_MODE = "CUSTOM_FIELD_3_SCANNER_MODE",
  CUSTOM_FIELD_4_SCANNER_MODE = "CUSTOM_FIELD_4_SCANNER_MODE",
  COMPONENT_NUMBER_CUSTOM_NAME = "COMPONENT_NUMBER_CUSTOM_NAME",
  LEV_NUMBER_CUSTOM_NAME = "LEV_NUMBER_CUSTOM_NAME",
  BATCH_NUMBER_CUSTOM_NAME = "BATCH_NUMBER_CUSTOM_NAME",
  SERIAL_NUMBER_CUSTOM_NAME = "SERIAL_NUMBER_CUSTOM_NAME",
  DELIVERY_NOTE_CUSTOM_NAME = "DELIVERY_NOTE_CUSTOM_NAME",
  MATERIAL_NUMBER_CUSTOM_NAME = "MATERIAL_NUMBER_CUSTOM_NAME",
  MEASURE_RESULT_1_CUSTOM_NAME = "MEASURE_RESULT_1_CUSTOM_NAME",
  MEASURE_RESULT_2_CUSTOM_NAME = "MEASURE_RESULT_2_CUSTOM_NAME",
  MEASURE_RESULT_3_CUSTOM_NAME = "MEASURE_RESULT_3_CUSTOM_NAME",
  CUSTOM_FIELD_1_CUSTOM_NAME = "CUSTOM_FIELD_1_CUSTOM_NAME",
  CUSTOM_FIELD_2_CUSTOM_NAME = "CUSTOM_FIELD_2_CUSTOM_NAME",
  CUSTOM_FIELD_3_CUSTOM_NAME = "CUSTOM_FIELD_3_CUSTOM_NAME",
  CUSTOM_FIELD_4_CUSTOM_NAME = "CUSTOM_FIELD_4_CUSTOM_NAME",
  COMPONENT_NUMBER_CODE_PREFIX = "COMPONENT_NUMBER_CODE_PREFIX",
  LEV_NUMBER_CODE_PREFIX = "LEV_NUMBER_CODE_PREFIX",
  BATCH_NUMBER_CODE_PREFIX = "BATCH_NUMBER_CODE_PREFIX",
  SERIAL_NUMBER_CODE_PREFIX = "SERIAL_NUMBER_CODE_PREFIX",
  DELIVERY_NOTE_CODE_PREFIX = "DELIVERY_NOTE_CODE_PREFIX",
  MATERIAL_NUMBER_CODE_PREFIX = "MATERIAL_NUMBER_CODE_PREFIX",
  MEASURE_RESULT_1_CODE_PREFIX = "MEASURE_RESULT_1_CODE_PREFIX",
  MEASURE_RESULT_2_CODE_PREFIX = "MEASURE_RESULT_2_CODE_PREFIX",
  MEASURE_RESULT_3_CODE_PREFIX = "MEASURE_RESULT_3_CODE_PREFIX",
  CUSTOM_FIELD_1_CODE_PREFIX = "CUSTOM_FIELD_1_CODE_PREFIX",
  CUSTOM_FIELD_2_CODE_PREFIX = "CUSTOM_FIELD_2_CODE_PREFIX",
  CUSTOM_FIELD_3_CODE_PREFIX = "CUSTOM_FIELD_3_CODE_PREFIX",
  CUSTOM_FIELD_4_CODE_PREFIX = "CUSTOM_FIELD_4_CODE_PREFIX",
  COMPONENT_NUMBER_AUTO_TRANSITION = "COMPONENT_NUMBER_AUTO_TRANSITION",
  LEV_NUMBER_AUTO_TRANSITION = "LEV_NUMBER_AUTO_TRANSITION",
  BATCH_NUMBER_AUTO_TRANSITION = "BATCH_NUMBER_AUTO_TRANSITION",
  SERIAL_NUMBER_AUTO_TRANSITION = "SERIAL_NUMBER_AUTO_TRANSITION",
  DELIVERY_NOTE_AUTO_TRANSITION = "DELIVERY_NOTE_AUTO_TRANSITION",
  MATERIAL_NUMBER_AUTO_TRANSITION = "MATERIAL_NUMBER_AUTO_TRANSITION",
  MEASURE_RESULT_1_AUTO_TRANSITION = "MEASURE_RESULT_1_AUTO_TRANSITION",
  MEASURE_RESULT_2_AUTO_TRANSITION = "MEASURE_RESULT_2_AUTO_TRANSITION",
  MEASURE_RESULT_3_AUTO_TRANSITION = "MEASURE_RESULT_3_AUTO_TRANSITION",
  CUSTOM_FIELD_1_AUTO_TRANSITION = "CUSTOM_FIELD_1_AUTO_TRANSITION",
  CUSTOM_FIELD_2_AUTO_TRANSITION = "CUSTOM_FIELD_2_AUTO_TRANSITION",
  CUSTOM_FIELD_3_AUTO_TRANSITION = "CUSTOM_FIELD_3_AUTO_TRANSITION",
  CUSTOM_FIELD_4_AUTO_TRANSITION = "CUSTOM_FIELD_4_AUTO_TRANSITION",
  COMPONENT_NUMBER_SCAN_SOUND = "COMPONENT_NUMBER_SCAN_SOUND",
  LEV_NUMBER_SCAN_SOUND = "LEV_NUMBER_SCAN_SOUND",
  BATCH_NUMBER_SCAN_SOUND = "BATCH_NUMBER_SCAN_SOUND",
  SERIAL_NUMBER_SCAN_SOUND = "SERIAL_NUMBER_SCAN_SOUND",
  DELIVERY_NOTE_SCAN_SOUND = "DELIVERY_NOTE_SCAN_SOUND",
  MATERIAL_NUMBER_SCAN_SOUND = "MATERIAL_NUMBER_SCAN_SOUND",
  MEASURE_RESULT_1_SCAN_SOUND = "MEASURE_RESULT_1_SCAN_SOUND",
  MEASURE_RESULT_2_SCAN_SOUND = "MEASURE_RESULT_2_SCAN_SOUND",
  MEASURE_RESULT_3_SCAN_SOUND = "MEASURE_RESULT_3_SCAN_SOUND",
  CUSTOM_FIELD_1_SCAN_SOUND = "CUSTOM_FIELD_1_SCAN_SOUND",
  CUSTOM_FIELD_2_SCAN_SOUND = "CUSTOM_FIELD_2_SCAN_SOUND",
  CUSTOM_FIELD_3_SCAN_SOUND = "CUSTOM_FIELD_3_SCAN_SOUND",
  CUSTOM_FIELD_4_SCAN_SOUND = "CUSTOM_FIELD_4_SCAN_SOUND",
}

export enum ReportSettingKeyboardType {
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
}

export enum ReportSettingScannerMode {
    SCANNER_MODE_GENERAL = 'SCANNER_MODE_GENERAL',
    SCANNER_MODE_NO_SCANNER = 'SCANNER_MODE_NO_SCANNER',
    SCANNER_MODE_SCANNER = 'SCANNER_MODE_SCANNER',
    SCANNER_MODE_SKIP_PREFIX = 'SCANNER_MODE_SKIP_PREFIX'
}